export enum JobStatuses {
  New = 0,
  In_Progress = 1,
  Slipped = 2,
  Complete = 3,
  //Jobs Phase 2
  //Approved = 4
}
